import React, { useEffect, useRef, useState } from "react"
import { Autocomplete, TextField } from "@mui/material"

export default function PenaltyEditor(props) {
  const { value, onValueChange, stopEditing } = props

  const [inputValue, setInputValue] = useState(value || '')
  const autoRef = useRef(null)

  const options = props.params.map(p => p.penaltyName)

  useEffect(() => {
    setTimeout(() => {
      autoRef.current?.focus()
      autoRef.current?.click()
    }, 0)
  }, [])

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (['ArrowDown', 'ArrowUp', 'Enter'].includes(e.key)) {
        e.stopPropagation()
      }
    }

    const input = document.querySelector('input')
    if (input) input.addEventListener('keydown', handleKeyDown)

    return () => input && input.removeEventListener('keydown', handleKeyDown)
  }, [])


  return (
    <Autocomplete
      sx={{ width: '100%' }}
      openOnFocus
      autoHighlight
      autoSelect
      options={['', ...options]} // first option is empty
      value={value || ''}
      inputValue={inputValue}
      onInputChange={(e, newInput) => setInputValue(newInput)}
      onChange={(e, newValue) => {
        onValueChange(newValue === null ? "" : newValue) // convert null to empty string
        stopEditing()
      }}
      getOptionLabel={(option) => option || ''} // handles empty string
      renderOption={(props, option) => (
        <li {...props}>
          {option === '' ? '\u00A0' : option} {/* blank row with full height via nbsp*/}
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="standard"
          inputRef={autoRef}
          fullWidth // ensures TextField fills cell
        />
      )}
    />


  )
}
